import { type as types } from "../types";

const user = JSON.parse(sessionStorage.getItem("user"));
const initialState = user ? { isLoggedIn: true, user, errorMessage: null, statusPass: 0 } : {isLoggedIn: false, user: null, errorMessage: null, statusPass: 0}

export const AuthReducer = (state = initialState, action) => {

    const {type, payload } = action;

    switch(type){
        
        case types.loginSucces:
            const data1 = {
                ...state,
                isLoggedIn: true,
                user: payload,
                errorMessage: null
            }
            return data1;
        case types.loginFail:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
                errorMessage: payload.errorMessage,
                statusPass: 0
            }
        case types.loginActPass:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
                errorMessage: payload.errorMessage,
                statusPass: payload.statusPass
            }

        case types.logout:
            const data = {
                ...state,
                isLoggedIn: false,
                user: null,
                errorMessage: null,
                statusPass: 0
            }
            return data;
        
        default:
            return state;
    }

}
